module.exports = __webpack_public_path__ + "static/media/Forestry-Yellow-BG-Front-Layer-One@2x.10130844.png";